export default __webpack_public_path__ + "static/groenhuysen-40bd9b5fc6dbf15b4b7f5b0c2ffc3f3b.png";